import styled from 'styled-components';
var ProductCareContainer = styled.aside.withConfig({
  displayName: "ProductCarestyles__ProductCareContainer",
  componentId: "k1x6ix-0"
})(["font-family:", ";font-weight:", ";font-size:", ";"], function (props) {
  return props.theme.font.family.brand;
}, function (props) {
  return props.theme.font.weight.regular;
}, function (props) {
  return props.theme.font.size.base;
});
var ProductCareTitle = styled.p.withConfig({
  displayName: "ProductCarestyles__ProductCareTitle",
  componentId: "k1x6ix-1"
})(["display:flex;align-items:center;&&{margin-bottom:0;}> svg{margin-right:7px;}"]);
export { ProductCareContainer, ProductCareTitle };